<script lang="ts">
  export let actions: boolean = false;
</script>

<div class="card">
  <slot name="media"></slot>
  <div class="content">
    <slot name="content"></slot>
  </div>

  {#if actions}
    <div class="ui bottom attached button blue">
      <slot name="actions"></slot>
    </div>
  {/if}
</div>
